import { call, put, takeLatest } from 'redux-saga/effects'
import { FavoritesActions, FavoritesTypes } from './favoritesSlice'
import api from '../../services/api'

const getErrorMessage = (response) =>
  response.data?.message || response.data?.error_description || response.data?.detail || response.data?.title || response.data?.description || response.data?.error || (typeof response.data === 'string' ? response.data : null) || response.problem

function* addListingToFavoritesSaga(action) {
  const { listingId } = action
  const response = yield call(api.addFavoriteListing, listingId)

  if (response.ok) {
    yield put(FavoritesActions.addListingToFavoritesSuccess(response.data))
  } else {
    yield put(FavoritesActions.addListingToFavoritesFailure(getErrorMessage(response)))
  }
}

function* getFavoriteListingSaga(action) {
  const { listingId } = action
  const response = yield call(api.getFavoriteListing, listingId)

  if (response.ok) {
    yield put(FavoritesActions.getFavoriteListingSuccess(response.data))
  } else {
    yield put(FavoritesActions.getFavoriteListingFailure(getErrorMessage(response)))
  }
}

function* fetchFavoriteListingsSaga(action) {
  const { options } = action
  const response = yield call(api.getFavoriteListings, options)

  if (response.ok) {
    yield put(FavoritesActions.fetchFavoriteListingsSuccess(response.data))
  } else {
    yield put(FavoritesActions.fetchFavoriteListingsFailure(getErrorMessage(response)))
  }
}

function* removeListingFromFavoritesSaga(action) {
  const { listingId } = action
  const response = yield call(api.removeFavoriteListing, listingId)

  if (response.ok) {
    yield put(FavoritesActions.removeListingFromFavoritesSuccess(response.data))
  } else {
    yield put(FavoritesActions.removeListingFromFavoritesFailure(getErrorMessage(response)))
  }
}

function* addLeadToFavoritesSaga(action) {
  const { leadId } = action
  const response = yield call(api.addFavoriteLead, leadId)

  if (response.ok) {
    yield put(FavoritesActions.addLeadToFavoritesSuccess(response.data))
  } else {
    yield put(FavoritesActions.addLeadToFavoritesFailure(getErrorMessage(response)))
  }
}

function* fetchFavoriteLeadsSaga(action) {
  const { options } = action
  const response = yield call(api.getFavoriteLeads, options)

  if (response.ok) {
    yield put(FavoritesActions.fetchFavoriteLeadsSuccess(response.data))
  } else {
    yield put(FavoritesActions.fetchFavoriteLeadsFailure(getErrorMessage(response)))
  }
}

function* removeLeadFromFavoritesSaga(action) {
  const { leadId } = action
  const response = yield call(api.removeFavoriteLead, leadId)

  if (response.ok) {
    yield put(FavoritesActions.removeLeadFromFavoritesSuccess(response.data))
  } else {
    yield put(FavoritesActions.removeLeadFromFavoritesFailure(getErrorMessage(response)))
  }
}

export default function* favoritesSaga() {
  yield takeLatest(FavoritesTypes.ADD_LISTING_TO_FAVORITES_REQUEST, addListingToFavoritesSaga)
  yield takeLatest(FavoritesTypes.GET_FAVORITE_LISTING_REQUEST, getFavoriteListingSaga)
  yield takeLatest(FavoritesTypes.FETCH_FAVORITE_LISTINGS_REQUEST, fetchFavoriteListingsSaga)
  yield takeLatest(FavoritesTypes.REMOVE_LISTING_FROM_FAVORITES_REQUEST, removeListingFromFavoritesSaga)
  yield takeLatest(FavoritesTypes.ADD_LEAD_TO_FAVORITES_REQUEST, addLeadToFavoritesSaga)
  yield takeLatest(FavoritesTypes.FETCH_FAVORITE_LEADS_REQUEST, fetchFavoriteLeadsSaga)
  yield takeLatest(FavoritesTypes.REMOVE_LEAD_FROM_FAVORITES_REQUEST, removeLeadFromFavoritesSaga)
}